import { NameDto } from './NameDto'

export enum TradingAccountType {
  Pro = 1,
  Classic = 2,
  VIP = 5,
  Raw = 3,
  MAM_Investor = 4,
}

export enum PlanValuesKeys {
  Pro = 'Pro',
  Classic = 'Classic',
  VIP = 'VIP',
  Raw = 'Raw',
}

export enum CalculationMethod {
  PER_LOT = 1,
  PER_MILLION_USD = 2,
  PER_SPREAD_SHARE = 4,
  PER_PERCENT_BASE_CURRENCY = 3,
  POINT_BASED = 5,
}

export enum PayoutSchemeAssetClassType {
  FxMetals = 1,
  Crypto = 2,
  Other = 3,
}

export enum SubIbAccountStatus {
  Active = 1,
  Inactive = 2,
}

export interface CommissionPlan {
  amount: number
  tradingAccountType: NameDto<TradingAccountType>
}

export interface UpdateCommissionPlan {
  amount: number
  tradingAccountTypeId: TradingAccountType
}

export interface PlanValues {
  [PlanValuesKeys.Classic]?: number
  [PlanValuesKeys.Pro]?: number
  [PlanValuesKeys.VIP]?: number
  [PlanValuesKeys.Raw]?: number
}

export const AccountTypeArr: string[] = [
  PlanValuesKeys.Classic,
  PlanValuesKeys.Pro,
  PlanValuesKeys.VIP,
  PlanValuesKeys.Raw,
]

export interface AssignedCommissionPlan {
  id: string
  name: string
  commissionPlans: CommissionPlan[]
  isDefault: boolean
}

export interface SubIBAccount {
  account: NameDto
  commissionPlanGroup: NameDto<string>
  clientName: string
  ibCommission: number
  volume: number
  status: NameDto
}

export interface SubIBAccountOption {
  id: string
  name: string
  commissionPlans: CommissionPlan[]
  isDefault: boolean
}

export interface IBNetworkPlans {
  introducingBroker: NameDto<string>
  level: number
  commissionPlanGroup: NameDto<string>
  numberOfClients: number
  subAccounts: IBNetworkPlans[]
}
